import { clsx } from '@alexis/helpers/clsx';
import CheckboxItem from '@pages/FlightSearchResult/components/CheckboxItem';
import { useFlightPLS } from '@pages/FlightSearchResult/contexts/FlightPerLegSearchContext/FlightPerLegSearchContext';
import { useFlightSearchResults } from '@pages/FlightSearchResult/contexts/FlightSearchResultsContext';
import useFlightSearchFilters from '@pages/FlightSearchResult/hooks/useFlightSearchFilters';
import useFlightSearchPageParams from '@pages/FlightSearchResult/hooks/useFlightSearchPageParams';
import { GenzoTrackApplyFilterActionEventType } from '@pages/FlightSearchResult/types';
import { useSelector } from 'react-redux';

import { convertFlightSearchResultFarePriceToPrice } from '@helpers/price';

import { getPriceOptionsState } from '@redux/selectors';

import styles from '../FlightFilterCategoryContent.module.scss';

type OriginDestinationFilterProps = {
  className?: string;
  genzoTrackApplyFilterActionEvent: GenzoTrackApplyFilterActionEventType;
  genzoTrackApplyFilterSearchView: () => void;
};

const OriginDestinationFilter: React.FC<OriginDestinationFilterProps> = ({
  className,
  genzoTrackApplyFilterActionEvent,
  genzoTrackApplyFilterSearchView,
}) => {
  const { exchangeRate, originAirportFilterOptions, destinationAirportFilterOptions } =
    useFlightSearchResults();
  const { isPerLegSearch } = useFlightPLS();

  const priceOptions = useSelector(getPriceOptionsState);

  const {
    activeLeg,
    originAirportCodesFilter,
    destinationAirportCodesFilter,
    handleOriginAirportCodeClick,
    handleDestinationAirportCodeClick,
  } = useFlightSearchFilters();

  const selectedOriginAirportsForActiveLeg =
    originAirportCodesFilter.find((item) => item.leg === activeLeg)?.values || [];

  const selectedDestinationAirportsForActiveLeg =
    destinationAirportCodesFilter.find((item) => item.leg === activeLeg)?.values || [];

  const { passengerCount } = useFlightSearchPageParams();

  return (
    <>
      {isPerLegSearch && activeLeg === 1 ? (
        <>
          {originAirportFilterOptions.length > 0 || destinationAirportFilterOptions.length > 0 ? (
            <div className={clsx(styles.categoryContent, className && styles.inDropdown)}>
              {originAirportFilterOptions.length > 0 ? (
                <>
                  <div className={styles.itemGroupHeader}>
                    {destinationAirportFilterOptions[0].city?.name}
                  </div>

                  {destinationAirportFilterOptions.map((destinationAirport) => (
                    <CheckboxItem
                      className={className}
                      key={destinationAirport.airport?.code}
                      isChecked={selectedDestinationAirportsForActiveLeg.includes(
                        destinationAirport.airport?.code || '',
                      )}
                      label={destinationAirport.airport?.name ?? ''}
                      exchangeRate={exchangeRate}
                      price={convertFlightSearchResultFarePriceToPrice(
                        destinationAirport.price!,
                        passengerCount,
                        priceOptions.showTotalPrice,
                        true,
                      )}
                      onCheckboxToggle={() =>
                        handleDestinationAirportCodeClick(
                          destinationAirport.airport?.code || '',
                          genzoTrackApplyFilterSearchView,
                          genzoTrackApplyFilterActionEvent,
                        )
                      }
                    />
                  ))}
                </>
              ) : null}

              {destinationAirportFilterOptions.length > 0 ? (
                <>
                  <div className={styles.itemGroupHeader}>
                    {originAirportFilterOptions[0].city?.name}
                  </div>

                  {originAirportFilterOptions.map((originAirport) => (
                    <CheckboxItem
                      className={className}
                      key={originAirport.airport?.code}
                      isChecked={selectedOriginAirportsForActiveLeg.includes(
                        originAirport.airport?.code || '',
                      )}
                      label={originAirport.airport?.name ?? ''}
                      exchangeRate={exchangeRate}
                      price={convertFlightSearchResultFarePriceToPrice(
                        originAirport.price!,
                        passengerCount,
                        priceOptions.showTotalPrice,
                        true,
                      )}
                      onCheckboxToggle={() =>
                        handleOriginAirportCodeClick(
                          originAirport.airport?.code || '',
                          genzoTrackApplyFilterSearchView,
                          genzoTrackApplyFilterActionEvent,
                        )
                      }
                    />
                  ))}
                </>
              ) : null}
            </div>
          ) : null}
        </>
      ) : (
        <>
          {originAirportFilterOptions.length > 0 || destinationAirportFilterOptions.length > 0 ? (
            <div className={clsx(styles.categoryContent, className && styles.inDropdown)}>
              {originAirportFilterOptions.length > 0 ? (
                <>
                  <div className={styles.itemGroupHeader}>
                    {originAirportFilterOptions[0].city?.name}
                  </div>

                  {originAirportFilterOptions.map((originAirport) => (
                    <CheckboxItem
                      className={className}
                      key={originAirport.airport?.code}
                      isChecked={selectedOriginAirportsForActiveLeg.includes(
                        originAirport.airport?.code || '',
                      )}
                      label={originAirport.airport?.name ?? ''}
                      exchangeRate={exchangeRate}
                      price={convertFlightSearchResultFarePriceToPrice(
                        originAirport.price!,
                        passengerCount,
                        priceOptions.showTotalPrice,
                        true,
                      )}
                      onCheckboxToggle={() =>
                        handleOriginAirportCodeClick(
                          originAirport.airport?.code || '',
                          genzoTrackApplyFilterSearchView,
                          genzoTrackApplyFilterActionEvent,
                        )
                      }
                    />
                  ))}
                </>
              ) : null}

              {destinationAirportFilterOptions.length > 0 ? (
                <>
                  <div className={styles.itemGroupHeader}>
                    {destinationAirportFilterOptions[0].city?.name}
                  </div>

                  {destinationAirportFilterOptions.map((destinationAirport) => (
                    <CheckboxItem
                      className={className}
                      key={destinationAirport.airport?.code}
                      isChecked={selectedDestinationAirportsForActiveLeg.includes(
                        destinationAirport.airport?.code || '',
                      )}
                      label={destinationAirport.airport?.name ?? ''}
                      exchangeRate={exchangeRate}
                      price={convertFlightSearchResultFarePriceToPrice(
                        destinationAirport.price!,
                        passengerCount,
                        priceOptions.showTotalPrice,
                        true,
                      )}
                      onCheckboxToggle={() =>
                        handleDestinationAirportCodeClick(
                          destinationAirport.airport?.code || '',
                          genzoTrackApplyFilterSearchView,
                          genzoTrackApplyFilterActionEvent,
                        )
                      }
                    />
                  ))}
                </>
              ) : null}
            </div>
          ) : null}
        </>
      )}
    </>
  );
};

export default OriginDestinationFilter;
